import Constants from "../../constants/constants.js";

export function getRoleLevelByID(roleID, roles) {
    let role;
    for (let index in roles) {
        role = roles[index];
        if (roleID === parseInt(role.id, 10)) {
            return role.level.toString();
        }
    }
}

export function getRoleIDByLevel(level, roles) {
    let role;
    for (let index in roles) {
        role = roles[index];
        if (level === parseInt(role.level, 10)) {
            return role.id.toString();
        }
    }
}

export function shouldShowUsageEmailCheckbox(role) {
    return role.level === Constants.BUSINESS_GROUP_ADMIN_ROLE_LEVEL ||
        role.level === Constants.REGIONAL_ADMIN_ROLE_LEVEL;
}


// WEBPACK FOOTER //
// ./src/services/utils/personnel.js